export const MAX_FILE_SIZE_IN_BYTES = 25 * 1000 * 1000;
